import { useMemo } from 'react';
import queryString from 'query-string';
import { useRouter } from '@atlassian/react-resource-router';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => {
	const [
		{
			match: { params },
			location,
		},
	] = useRouter();

	const routerProps = useMemo(() => {
		const reportId = params.reportId || '';
		const timescaleId = params.timescaleId !== undefined ? Number(params.timescaleId) : undefined;
		const {
			startTime: startDate,
			endTime: endDate,
			timeBreakdown,
		} = queryString.parse(location.search);

		return {
			reportId,
			timescaleId,
			startDate,
			endDate,
			timeBreakdown,
		};
	}, [location.search, params.reportId, params.timescaleId]);

	return routerProps;
};
